import React, { useState } from 'react'
// import Dropdown from './Dropdown'
import SimpleBar from "simplebar-react";
import ChatInput from './ChatInputs';
import Header from './HeaderTop';

const Conversations = () => {
  const [msg, setMsg] = useState('');
  const [isDrag, setDrag] = useState(false);
  const [isOpen, setOpen] = useState(null)
  const toggle = () => 0
  const [messages, setMessages] = useState([
    {
      id: 1,
      message: 'hello',
      time: "00:00",
      userType: "sender",
      image: null,
      isFileMessage: false,
      isImageMessage: false
    },
    {
      id: 1,
      message: 'hey, AI chatbot here',
      time: "00:00",
      userType: "AI",
      image: null,
      isFileMessage: false,
      isImageMessage: false
    }
  ])
  const handleImageChange = () => 0
  const handleFileChange = () => 0
  const onEmojiClick = () => 0

  const addMessage = (message, type) => {
    var messageObj = null;

    let d = new Date();
    var n = d.getSeconds();

    //matches the message type is text, file or image, and create object according to it
    switch (type) {
      case "textMessage":
        messageObj = {
          id: messages.length + 1,
          message: message,
          time: "00:" + n,
          userType: "sender",
          image: null,
          isFileMessage: false,
          isImageMessage: false
        }
        break;

      case "fileMessage":
        messageObj = {
          id: messages.length + 1,
          message: 'file',
          fileMessage: message.name,
          size: message.size,
          time: "00:" + n,
          userType: "sender",
          image: null,
          isFileMessage: true,
          isImageMessage: false
        }
        break;

      case "imageMessage":
        var imageMessage = [
          { image: message },
        ]

        messageObj = {
          id: messages.length + 1,
          message: 'image',
          imageMessage: imageMessage,
          size: message.size,
          time: "00:" + n,
          userType: "sender",
          image: null,
          isImageMessage: true,
          isFileMessage: false
        }
        break;

      default:
        break;
    }
    setMsg((prev) => prev = '')       
    setMessages([...messages, messageObj]);
  }

  return (
    <div>
      <div className="bg-white w-100 mt-2 position-relative">
        <div className="w-100" style={{ height: "calc(100vh - 103px)" }}>
          <Header text="Consult" />

          <SimpleBar
            style={{ maxHeight: "100%" }}
            className="chat-conversation p-3 p-lg-4"
            id="messages">
            <ul className="list-unstyled mb-0">
              {
                messages.map((msg, key) =>
                  // chat.isToday && chat.isToday === true ? <li key={"dayTitle" + key}>
                  //     <div className="chat-day-title">
                  //         <span className="title">Today</span>
                  //     </div>
                  // </li> :

                  <li key={key} className={msg.userType === "sender" ? "right" : ""}>
                    <div className="conversation-list">

                      <div className="chat-avatar">
                        {msg.userType === "sender" ? <div className="chat-user-img align-self-center">
                          <div className="avatar-xs">
                            <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                              {"S"}
                            </span>
                          </div>
                        </div> :

                          <div className="chat-user-img align-self-center">
                            <div className="avatar-xs">
                              <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                {"AI"}
                              </span>
                            </div>
                          </div>

                        }
                      </div>

                      <div className="user-chat-content">
                        <div className="ctext-wrap">
                          <div className="ctext-wrap-content">
                              <p className="mb-0">
                                {msg.message}
                              </p>
                              
                              <p className="chat-time mb-0"><i className="ri-time-line align-middle"></i> <span className="align-middle">{msg.time}</span></p>
                          </div>

                        </div>
                        {/* {
                                                        <div className="conversation-name">{"Patricia Smith"}</div>
                                                    } */}
                      </div>
                    </div>
                  </li>
                )
              }
            </ul>
          </SimpleBar>

          <ChatInput
            onaddMessage={addMessage}
            isDrag={isDrag}
            setDrag={setDrag}
          />

        </div>
      </div>
    </div>
  )
}

export default Conversations